var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rating
    ? _c("RatingStars", {
        staticClass: "relative bottom-1",
        attrs: {
          value: _vm.rating,
          starSize: 15,
          increment: 0.1,
          readOnly: "",
        },
      })
    : _c("Badge", {
        staticClass: "inline-flex",
        attrs: { value: _vm.notRatedText, color: _vm.badgeColor.INFO },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }